import * as React from "react";
import {useState} from "react";
import Box from "@mui/material/Box";
import {Alert, Collapse} from "@mui/material";

interface infoProps {
    sec: number;
    text: string;
    severity: string;
}

export function Information({sec, text, severity}: infoProps) {
    const [open, setOpen] = useState(false);
    const severity_s = ["success", "info", "warning", "error"]

    setTimeout(() => {
        setOpen(true)
    }, 500)

    setTimeout(() => {
        setOpen(false)
    }, sec * 1000);

    return (
        <Box textAlign="center">
            <Collapse in={open}>
                {/*@ts-ignore*/}
                <Alert severity={severity_s.includes(severity) ? severity : "success"} sx={{mb: 2}}>
                    {text}
                </Alert>
            </Collapse>
        </Box>
    )
}